/* Smart search for zevpoint.com: an answer on top of the theme's own search.
 *
 * Type a car -> the chargers that charge it at full speed (each charger's car
 * list, which DataVault writes daily; see snippets/zev-smart-search.liquid)
 * and, when one car is meant, only those chargers among the search results.
 * Type a common question -> the page that answers it (INTENTS below).
 *
 * Theme-agnostic: reads input[name=q], adds a card to the predictive-search
 * dropdown ([data-predictive-search]) and to the /search page. Nothing else in
 * the theme is touched. Source of truth: DataVault repo, marketing_module/shopify/.
 */
(function () {
  'use strict';
  if (window.__zevSmartSearch) return;
  window.__zevSmartSearch = true;

  var DATA;
  try { DATA = JSON.parse(document.getElementById('zev-smart-search-data').textContent); }
  catch (e) { return; }
  var CHARGERS = DATA.chargers || [];

  /* ---------------------------------------------------------------- cars */

  var BY_CAR = {};
  CHARGERS.forEach(function (c) {
    (c.c || []).forEach(function (name) { (BY_CAR[name] = BY_CAR[name] || []).push(c); });
  });
  /* Every charger we sell, DC included: the ones a named car does not suit
   * are hidden from the results. */
  var CHARGER_HANDLES = CHARGERS.map(function (c) { return c.h; }).concat(DATA.x || []);

  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  function wordset(s) { var o = {}; s.split(' ').forEach(function (w) { o[w] = 1; }); return o; }

  var CARS = Object.keys(BY_CAR).map(function (n) { return { n: n, t: norm(n).split(' ') }; });
  /* Words that say nothing about which car: "ev charger for my car". */
  var STOP = wordset('ev evs charger chargers charging charge car cars for my the a an of kw home wall ' +
    'portable best price prices cost buy which what suits suit suitable compatible compatibility with to ' +
    'in and plug socket fast electric vehicle type is it does work works need');
  /* Words in car names that never pick a car on their own. */
  var WEAK = wordset('pro max plus prime lr mr long range new');

  /* Cars the query names. Every word must fit the car, except filler and bare
   * numbers ("nexon 45" is a variant hint); the most specific matches win. */
  function findCars(q) {
    var toks = norm(q).split(' ').filter(function (t) { return t && !STOP[t]; });
    if (!toks.length) return [];
    var best = 0, hits = [];
    CARS.forEach(function (car) {
      var strong = 0;
      for (var i = 0; i < toks.length; i++) {
        var t = toks[i];
        var hit = car.t.some(function (w) { return w === t || (t.length >= 3 && w.indexOf(t) === 0); });
        if (hit) { if (!WEAK[t] && t.length >= 2) strong++; }
        else if (!/^\d+$/.test(t)) return;
      }
      if (!strong) return;
      if (strong > best) { best = strong; hits = []; }
      if (strong === best) hits.push(car.n);
    });
    return hits.sort();
  }

  /* ------------------------------------------------------------- intents */

  var FINDER = '/#find-your-charger';
  var INTENTS = [
    { k: ['track', 'where is my order', 'order status', 'awb', 'shipment', 'dispatched', 'not delivered', 'not received'],
      title: 'Track an order or a request',
      links: [['Your orders', '/account'], ['Track a repair', '/pages/track-repair'],
              ['Track a service or installation', '/pages/track-service']] },
    { k: ['repair', 'not working', 'service', 'complaint', 'problem', 'fault', 'error', 'broken', 'issue', 'defect', 'stopped', 'trip'],
      title: 'Something not working?',
      links: [['Raise a service request', '/pages/service-request'], ['Track a repair', '/pages/track-repair']] },
    { k: ['install', 'fitting', 'electrician', 'wiring', 'survey', 'mounting'],
      title: 'Installation',
      links: [['Book at-home installation', '/products/at-home-installation'],
              ['Pre-installation survey', '/products/pre-installation-survey'],
              ['Installation and service policy', '/pages/installation-policy']] },
    { k: ['warranty', 'guarantee'],
      title: 'Warranty',
      links: [['Our warranty', '/pages/warranty'], ['Extended warranty', '/pages/extended-warranty']] },
    { k: ['return', 'refund', 'replace', 'exchange', 'cancel'],
      title: 'Returns and refunds',
      links: [['Easy return policy', '/pages/easy-return-policy'], ['Request a return', '/pages/easy-return-request']] },
    { k: ['cod', 'cash on delivery', 'shipping', 'delivery', 'invoice', 'gst'],
      title: 'Shipping, COD and GST invoice',
      links: [['Shipping and exchange', '/pages/shipping-exchange']] },
    { k: ['contact', 'call', 'phone', 'whatsapp', 'support', 'help', 'email', 'customer care', 'talk'],
      title: 'Talk to us',
      links: [['Contact us', '/pages/contact']] },
    { k: ['dc', 'fast charger', 'charging station', 'business', 'fleet', 'commercial', 'petrol pump', 'highway', 'ccs', 'dual gun', 'hotel', 'mall'],
      title: 'DC fast charging for business',
      links: [['DC chargers', '/pages/dc-chargers'], ['Plan and build a station', '/pages/dc-plan-and-build'],
              ['Site survey and proposal', '/pages/dc-site-survey']] },
    { k: ['apartment', 'society', 'rwa', 'community', 'flat', 'residential', 'building'],
      title: 'Apartments and housing societies',
      links: [['Chargers for apartments and societies', '/pages/community-charging']] },
    { k: ['which charger', 'find', 'recommend', 'suggest', 'compatible', 'compatibility', 'right charger', 'my car', 'suits'],
      title: 'Not sure which charger?', finder: true,
      links: [['Find the right charger for your car', FINDER]] },
    { k: ['dealer', 'partner', 'distributor', 'franchise', 'reseller'],
      title: 'Work with us',
      links: [['Become a partner', '/pages/partner-registration-form']] },
    { k: ['faq', 'how to', 'guide', 'help'],
      title: 'Guides and answers',
      links: [['FAQs', '/pages/tips-faqs'], ['Guides', '/pages/guides']] }
  ];

  /* A one-word key also matches longer forms ("install" -> "installation")
   * when it is four letters or more; a phrase must appear as written. */
  function intentsFor(q) {
    var n = norm(q), padded = ' ' + n + ' ', toks = n.split(' ');
    return INTENTS.filter(function (it) {
      return it.k.some(function (k) {
        if (k.indexOf(' ') !== -1) return padded.indexOf(' ' + k + ' ') !== -1;
        return toks.some(function (t) { return t === k || (k.length >= 4 && t.indexOf(k) === 0); });
      });
    });
  }

  /* --------------------------------------------------------------- cards */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function slug(n) { return n.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function num(s) { var m = String(s).match(/\d[\d,]*(\.\d+)?/); return m ? parseFloat(m[0].replace(/,/g, '')) : 0; }
  function supply(c) { return c.s && c.t ? 'single or three-phase' : (c.t ? 'three-phase' : 'single-phase'); }

  function carCard(name) {
    var list = BY_CAR[name].slice().sort(function (a, b) {
      return (num(a.kw) - num(b.kw)) || (num(a.p) - num(b.p));
    });
    var items = list.slice(0, 6).map(function (c) {
      return '<li><a href="' + esc(c.u) + '">' +
        (c.i ? '<img src="' + esc(c.i) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="zss-noimg"></span>') +
        '<span class="zss-txt"><span class="zss-name">' + esc(c.n) + '</span>' +
        '<span class="zss-meta">' + esc((c.kw ? c.kw + ' kW, ' : '') + supply(c)) + ' &middot; ' +
        esc(String(c.p).replace(/\.00$/, '')) + '</span></span></a></li>';
    }).join('');
    var threePhase = list.every(function (c) { return c.t; });
    return '<div class="zss-card"><p class="zss-kicker">For your ' + esc(name) + '</p>' +
      '<p class="zss-lead">These charge it at full speed:</p><ul class="zss-products">' + items + '</ul>' +
      (threePhase ? '<p class="zss-note">Full speed needs a three-phase supply. On a single-phase home, a 7.5 kW charger is the fastest choice.</p>' : '') +
      '<a class="zss-cta" href="/?ev=' + esc(slug(name)) + '">Not sure which one? Answer two questions &rarr;</a></div>';
  }

  function pickCard(names) {
    var items = names.slice(0, 8).map(function (n) {
      var kw = Math.min.apply(null, BY_CAR[n].map(function (c) { return num(c.kw) || 99; }));
      return '<li><a href="/search?q=' + encodeURIComponent(n) + '">' + esc(n) +
        '<span class="zss-meta">' + (kw < 99 ? esc(kw) + ' kW chargers' : '') + '</span></a></li>';
    }).join('');
    return '<div class="zss-card"><p class="zss-kicker">Which one is yours?</p><ul class="zss-cars">' + items + '</ul></div>';
  }

  function linkCard(it) {
    return '<div class="zss-card zss-card--links"><p class="zss-kicker">' + esc(it.title) + '</p><ul class="zss-links">' +
      it.links.map(function (l) { return '<li><a href="' + esc(l[1]) + '">' + esc(l[0]) + ' &rarr;</a></li>'; }).join('') +
      '</ul></div>';
  }

  function answer(q) {
    var cars = q.length >= 2 ? findCars(q) : [];
    var parts = [];
    if (cars.length === 1) parts.push(carCard(cars[0]));
    else if (cars.length > 1) parts.push(pickCard(cars));
    intentsFor(q).filter(function (it) { return !(cars.length && it.finder); }).slice(0, 2)
      .forEach(function (it) { parts.push(linkCard(it)); });
    return { html: parts.join(''), cars: cars };
  }

  /* When the query names cars, hide the chargers that do not suit them
   * (all chargers when the card above already lists them); accessories and
   * everything else stay, and a list left empty goes with its heading. */
  function filterResults(scope, cars, cardListsThem) {
    if (!scope || !cars.length) return;
    var ok = {};
    if (!cardListsThem) cars.forEach(function (n) { BY_CAR[n].forEach(function (c) { ok[c.h] = 1; }); });
    scope.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (a.closest('.zss')) return;
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m || ok[m[1]] || CHARGER_HANDLES.indexOf(m[1]) === -1) return;
      var li = a.closest('li');
      if (li) li.style.display = 'none';
    });
    scope.querySelectorAll('ul').forEach(function (ul) {
      if (ul.closest('.zss') || !ul.children.length) return;
      var shown = Array.prototype.some.call(ul.children, function (li) { return li.style.display !== 'none'; });
      if (!shown && ul.parentNode !== scope) ul.parentNode.style.display = 'none';
    });
  }

  /* --------------------------------------------------------------- mount */

  function card(q, a, extraClass) {
    var div = document.createElement('div');
    div.className = 'zss' + (extraClass || '');
    div.setAttribute('data-q', q);
    div.innerHTML = a.html;
    return div;
  }

  function decorateDropdown(box, input) {
    var q = input.value.trim(), old = box.querySelector('.zss');
    if (old && old.getAttribute('data-q') === q) return;
    if (old) old.parentNode.removeChild(old);
    if (!q) return;
    var a = answer(q);
    if (a.html) {
      var host = box.querySelector('#predictive-search-results') || box;
      host.insertBefore(card(q, a), host.firstChild);
    }
    filterResults(box, a.cars, a.cars.length === 1);
  }

  function watchDropdowns() {
    document.querySelectorAll('[data-predictive-search]').forEach(function (box) {
      var root = box.closest('predictive-search') || box.closest('form') || document;
      var input = root.querySelector('input[name="q"]');
      if (!input || box.__zss) return;
      box.__zss = true;
      new MutationObserver(function () { decorateDropdown(box, input); }).observe(box, { childList: true });
    });
  }

  function decorateSearchPage() {
    if (!/^\/search\/?$/.test(location.pathname)) return;
    var q = (new URLSearchParams(location.search).get('q') || '').trim();
    if (!q) return;
    var a = answer(q);
    var grid = document.querySelector('#ProductGridContainer, .template-search__results, #product-grid');
    filterResults(grid, a.cars);
    if (!a.html) return;
    var header = document.querySelector('.template-search__header');
    var div = card(q, a, ' zss--page page-width');
    if (header && header.parentNode) header.parentNode.insertBefore(div, header.nextSibling);
    else (document.querySelector('main') || document.body).insertAdjacentElement('afterbegin', div);
  }

  var CSS = '.zss{padding:12px 16px 4px;text-align:left}' +
    '.zss--page{margin:0 auto 24px;max-width:760px}' +
    '.zss-card{margin:0 0 12px;padding:12px 14px;border:1px solid rgba(var(--color-foreground,18,18,18),.14);border-radius:10px}' +
    '.zss-kicker{margin:0 0 4px;font-size:12px;letter-spacing:.06em;text-transform:uppercase;font-weight:600;color:#0d7a40}' +
    '.zss-lead,.zss-note{margin:0 0 8px;font-size:14px;line-height:1.45}' +
    '.zss-note{margin:8px 0;opacity:.8}' +
    '.zss ul{list-style:none;margin:0;padding:0}' +
    '.zss-products li a{display:flex;align-items:center;gap:10px;padding:6px 0;text-decoration:none;color:inherit}' +
    '.zss-products img,.zss-noimg{width:44px;height:44px;object-fit:contain;border-radius:6px;flex:none;background:rgba(var(--color-foreground,18,18,18),.04)}' +
    '.zss-txt{display:flex;flex-direction:column;min-width:0}' +
    '.zss-name{font-size:14px;font-weight:600;line-height:1.3}' +
    '.zss-meta{font-size:12px;opacity:.75;line-height:1.35}' +
    '.zss-cars li a{display:flex;justify-content:space-between;gap:12px;padding:6px 0;font-size:14px;text-decoration:none;color:inherit}' +
    '.zss-links li a,.zss-cta{display:inline-block;padding:4px 0;font-size:14px;font-weight:600;color:#0d7a40;text-decoration:none}' +
    '.zss a:hover .zss-name,.zss-cars a:hover,.zss-links a:hover,.zss-cta:hover{text-decoration:underline}';

  function init() {
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);
    watchDropdowns();
    decorateSearchPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* For checking a query from the browser console. */
  window.zevSmartSearch = { findCars: findCars, intentsFor: intentsFor };
})();
